<bd-checkbox-squared
    [name]="name + '-checkbox'"
    [(ngModel)]="isTextareaVisible"
    [disabled]="disabled"
    [checkboxColor]="'rgb(25, 101, 225)'"
    (ngModelChange)="updateTextareaState()"
    [disabled]="disabled">
    {{label}}
</bd-checkbox-squared>

<bd-labeled-textarea
    [disabled]="disabled"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    (ngModelChange)="updateChanges()"
    [cols]="cols" [rows]="rows"
    [name]="name"
    [ngClass]="{'is-visible':isTextareaVisible}">
</bd-labeled-textarea>
